import type { AimOfAnalysis } from "@/generated/fastapi";

export const backlogKeys = {
  all: ["backlog"] as const,
  topicsForOrigin: ({
    aim,
    onlyConfirmed,
    originId,
  }: {
    aim?: AimOfAnalysis | null;
    onlyConfirmed: boolean;
    originId: string;
  }) =>
    [
      ...backlogKeys.all,
      "topics-for-origin",
      { aim: aim ?? null, onlyConfirmed, originId },
    ] as const,
};
